"use client";
import ImageMember from "../../assets/images/Julian.jpeg"
import React from "react";

export function Testimonial1() {
  return (
    <section id="relume" className="px-[5%] py-16 md:py-24 lg:py-28">
      <div className="container w-full max-w-lg  md:max-w-5xl lg:max-w-7xl mx-auto">
        <div className="flex flex-col items-center text-center">
          <div className="mb-6 md:mb-8">
           
          </div>
          <blockquote className="text-xl font-bold md:text-2xl">
          "Seit wir mit Bollwerk X zusammenarbeiten, fühlen wir uns endlich sicher vor Cyberbedrohungen. Ihr proaktiver Ansatz, gepaart mit ihrer tiefgehenden Expertise, hat unsere IT-Sicherheit auf ein völlig neues Level gehoben. Das Team ist jederzeit erreichbar, handelt blitzschnell und denkt immer einen Schritt voraus – echte Profis! "
          </blockquote>
          <div className="mt-6 flex flex-col items-center justify-center md:mt-8">
            <div className="mb-3 md:mb-4">
              <img
                src={ImageMember}
                alt="Testimonial avatar"
                className="size-16 min-h-16 min-w-16 rounded-full object-cover"
              />
            </div>
            <p className="font-semibold">Julian Stechert</p>
            <p>CEO, Deutsche Hörakustik</p>
          </div>
        </div>
      </div>
    </section>
  );
}
